<template>
    <span class="totem-learningpath-level" v-tooltip="{ content: $t(`Select.difficulty_level_note_${level.id}`), html: true }">
        {{ level.id }}
    </span>
</template>

<script>
    export default {
        name: 'totem-learningpath-level',
        props: {
            level: Object
        }
    }
</script>

<style lang="scss" scoped>
    .totem-learningpath-level {
        font-family: Nunito-Bold, sans-serif;
        padding: 0 10px 0 0;
        cursor: pointer;
    }
</style>
